export function getScaledUnit(unit: string, scalingFactor: number | null): string {
  if (!scalingFactor || scalingFactor === 1 || unit === '') {
    return unit;
  }

  const prefixes = [
    { value: 1e24, symbol: 'Y' },
    { value: 1e21, symbol: 'Z' },
    { value: 1e18, symbol: 'E' },
    { value: 1e15, symbol: 'P' },
    { value: 1e12, symbol: 'T' },
    { value: 1e9, symbol: 'G' },
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'k' },
    { value: 1000, symbol: 'k' },
    { value: 1, symbol: '' },
    { value: 1e-3, symbol: 'm' },
    { value: 0.001, symbol: 'm' },
    { value: 1e-6, symbol: 'µ' },
    { value: 1e-9, symbol: 'n' },
    { value: 1e-12, symbol: 'p' },
    { value: 1e-15, symbol: 'f' },
    { value: 1e-18, symbol: 'a' },
    { value: 1e-21, symbol: 'z' },
    { value: 1e-24, symbol: 'y' },
  ];

  const prefix = prefixes.find((p) => p.value === scalingFactor);
  return prefix ? `${prefix.symbol}${unit}` : unit;
}

export function getDisplayValues(name: string, scalingFactor: number | null, unit: string, value: number) {
  // Apply unit scaling and value scaling
  let displayValue = value;
  let displayName = name;
  if (scalingFactor && scalingFactor !== 1) {
    const scaledUnit = getScaledUnit(unit, scalingFactor);
    displayValue = value / scalingFactor;
    displayName = displayName.replace(`[${unit}]`, `[${scaledUnit}]`);
  }
  return { displayName, displayValue };
}
